import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const index = [
  {
    path: '/',
    name: 'Home',
    component: () => import('../views/ecommerce/paypeshop/Home.vue')
  }
]

export default new VueRouter({
  routes: index
})
